require('rails_sortable');

export default class Sortable {
  initializeListeners() {
    $('.sortable').railsSortable();
  }
}
